import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { injectIntl } from 'react-intl';

import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import styles from './LeaveReviewModal.styles';

class LeaveReviewModal extends Component {
  constructor(props) {
    super(props);

    this.handleOnSaveClick = this.handleOnSaveClick.bind(this);
    this.handleOnDismissClick = this.handleOnDismissClick.bind(this);
  }

  handleOnDismissClick() {
    const { handleDismissChanges, hideModal } = this.props;

    handleDismissChanges();
    hideModal();
  }

  handleOnSaveClick() {
    const { handleActionClick, hideModal } = this.props;

    handleActionClick();
    hideModal();
  }

  render() {
    const { classes, hideModal, title, intl } = this.props;

    return (
      <EcModalCard
        title={title}
        content={
          <div className={classes.modalBodyContent}>
            <p className={classes.modalInfo}>
              {intl.formatMessage({
                id: 'LeaveReviewModal.unsavedChangesMessage',
                defaultMessage:
                  'You have unsaved changes, are you sure you want to leave this page?',
                description: 'Warning message about unsaved changes',
              })}
            </p>
          </div>
        }
        footer={
          <>
            <Button
              variant="tertiary"
              text={intl.formatMessage({
                id: 'LeaveReviewModal.dismissChangesButton',
                defaultMessage: 'Dismiss changes and continue',
                description: 'Button text to dismiss changes and continue',
              })}
              onClick={this.handleOnDismissClick}
            />
            <Button
              variant="primary"
              text={intl.formatMessage({
                id: 'LeaveReviewModal.saveChangesButton',
                defaultMessage: 'Save changes and continue',
                description: 'Button text to save changes and continue',
              })}
              onClick={this.handleOnSaveClick}
            />
          </>
        }
        hideModal={hideModal}
      />
    );
  }
}

LeaveReviewModal.propTypes = {
  title: PropTypes.string.isRequired,
  handleDismissChanges: PropTypes.func.isRequired,
  handleActionClick: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectSheet(styles)(injectIntl(LeaveReviewModal));
